var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 57,
    viewBox: "0 0 53 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2162 1.9375C10.8731 1.9375 2.49414 9.83991 2.49414 19.581C2.49414 24.9746 5.06803 29.8043 9.11498 33.0405C8.00623 35.6637 5.98671 37.7884 3.47618 38.9897C4.24439 39.1614 5.03635 39.2512 5.85208 39.2512C8.98827 39.2512 11.8235 37.9355 13.8747 35.8108C16.1318 36.7179 18.6107 37.2164 21.2162 37.2164C31.5593 37.2164 39.9383 29.314 39.9383 19.5729C39.9383 9.83173 31.5593 1.9375 21.2162 1.9375Z",
    stroke: "#51515C",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6608 22.6055C46.4083 24.5423 51.3185 30.4507 51.3185 37.4378C51.3185 42.1776 49.0614 46.4189 45.5055 49.2628C46.4796 51.5673 48.2536 53.4306 50.4553 54.4929C49.7821 54.64 49.0852 54.7218 48.3645 54.7218C45.6084 54.7218 43.1217 53.5695 41.316 51.6981C39.3361 52.499 37.1502 52.9403 34.8614 52.9403C25.7776 52.9403 18.2539 45.569 18.2539 37.0047",
    stroke: "#51515C",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18555 19.2731H10.7894L12.9801 14.856L16.6094 24.0198L21.1743 12.7793L25.6542 26.014L30.1766 15.2103L32.712 19.6521H34.3161",
    stroke: "#12A46F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4751 36.9795H41.5434L39.2726 33.9395L34.047 41.3679L31.7402 38.9171",
    stroke: "#12A46F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg06);
export default __webpack_public_path__ + "static/media/06.e3630ed755198d20cef26f0e01c5876b.svg";
export { ForwardRef as ReactComponent };